import { ApplicationState } from '@/store';
import { authSAMLRequest } from '@/store/identity/action';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const Saml: React.FC = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();

    const { hasError, user } = useSelector((state: ApplicationState) => ({
        hasError: state.identity.hasError,
        user: state.identity.data.user,
    }));

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const bearerToken = params.get('token');

        if (!hasError && bearerToken) {
            dispatch(authSAMLRequest(bearerToken));
        } else {
            history.push('/logout');
        }
    }, [hasError]);

    useEffect(() => {
        if (user) {
            history.push('/');
        }
    }, [user]);

    return null;
};

export default Saml;
